
import Scroll from './Scroll'


const scroll = new Scroll()


export default
{
    name: 'core-scroll',

    created()
    {
        this.scroll = scroll
    },

    mounted()
    {
        if (this.onScroll)
        {
            if (this.$root.isFakeScroll)
            {
                this.scroll.addOnSmoothScroll(this.onScroll)
            }
            else
            {
                this.scroll.addOnScroll(this.onScroll)
            }
        }
        else
        {
            console.warn(`Use the method onScroll(y) if you use the mixin core-scroll in your component ${this.$options.name}`)
        }
    },

    destroyed()
    {
        if (this.onScroll)
        {
            if (this.$root.isFakeScroll)
            {
                this.scroll.removeOnSmoothScroll(this.onScroll)
            }
            else
            {
                this.scroll.removeOnScroll(this.onScroll)
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/mixins/core-scroll/index.js